import { Image } from "@nextui-org/react";
import Button from "../../../../components/Button";
import aboutContent from "@/content/home/aboutContent";

function About() {
    return (
        <section className="relative pt-4 pb-72 md:pb-32">
            <div className="container flex flex-col items-center justify-around mx-auto gap-9 lg:flex-row">
                <div>
                    <Image
                        src={aboutContent.image.src}
                        alt={aboutContent.image.alt}
                        loading="lazy"
                        decoding="async"
                        disableSkeleton
                        height={"100%"}
                        className="w-[300px] md:w-[450px]"
                    />
                </div>
                <div className="flex flex-col items-center gap-5 px-10 text-center md:items-start md:text-right lg:w-1/2">
                    <h2 className="text-xl md:text-4xl text-text-color-primary">
                        <span className="text-text-color-primary">
                            {aboutContent.header.highlight}
                        </span>{" "}
                        {aboutContent.header.title}
                    </h2>
                    <p className="w-full leading-7 tracking-wide text-center lg:w-9/12 md:text-right text-text-color-primary text-pretty">
                        {aboutContent.description}
                    </p>
                    <Button
                        type="customized"
                        to={aboutContent.button.link}
                        className="inline-block w-40 px-4 py-2 mt-3 font-semibold leading-8 tracking-wide text-center text-white transition-colors duration-300 rounded-full disabled:cursor-not-allowed md:px-6 bg-primary-color-primary hover:bg-primary-color-dark hover:text-text-color-secondary"
                    >
                        <span className="text-xl font-semibold text-text-color-secondary">
                            {aboutContent.button.text}
                        </span>
                    </Button>
                </div>
            </div>
            <img
                src={aboutContent.waveImage.src}
                alt={aboutContent.waveImage.alt}
                className="absolute bottom-0 left-0 w-[200px] xl:w-[250px]"
                loading="lazy"
                decoding="async"
            />
        </section>
    );
}

export default About;
